import { CssBaseline, ThemeProvider, StyledEngineProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ApiError } from "src/types/interfaces/api-error";
import { RTL } from "./rtl";
import { createCustomTheme } from "src/theme";
import { useSettings } from "src/contexts/settings-context";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { pl } from "date-fns/locale";
import { enUS } from "date-fns/locale";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { TechnicalBrake } from "src/containers/technical-brake/technical-brake";
import { MaintenanceGuard } from "./guards/maintenance-guard";
import { useUpdateLanguage } from "src/hooks/use-update-language";

// declare module '@mui/styles/defaultTheme' {
//   // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme {}
// }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: error => {
        const apiError = error as ApiError;

        if (apiError?.response?.status >= 500) {
          return true;
        }
        return false;
      },
      retry: false,
    },
  },
});

export const Providers = ({ children }: { children: ReactNode }) => {
  const { settings } = useSettings();

  const theme = createCustomTheme({
    direction: settings.direction,
    theme: settings.theme,
  });

  useUpdateLanguage();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <RTL direction={settings.direction}>
          <CssBaseline />
          <LocalizationProvider
            adapterLocale={settings.language === "en" ? enUS : pl}
            dateAdapter={AdapterDateFns}>
            <ErrorBoundary FallbackComponent={TechnicalBrake}>
              <QueryClientProvider client={queryClient}>
                {/*
                    //? should MaintenanceGuard be without the need of user to login
                    //? have to think about that case
                  */}
                <MaintenanceGuard>{children}</MaintenanceGuard>
                <ReactQueryDevtools initialIsOpen={false} />
              </QueryClientProvider>
            </ErrorBoundary>
          </LocalizationProvider>
        </RTL>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
